module.exports = __webpack_public_path__ + "static/store-80166b9f95022eaf3e4f63ef85ffc7e5.jpg";